/* labmat-quote.js — localStorage quote cart: header count badge, toast, and the
   legacy /pages/quote list. The visible cart popup is rendered by
   snippets/quote-modal.liquid (#js-qcm); this file no longer renders its own
   modal (that dead code previously left <body> scroll-locked). Every reader /
   writer shares localStorage key labmatQuote.v3 and stays in sync via the
   document 'labmatQuote:changed' event. */
(function(){
  'use strict';
  var KEY = 'labmatQuote.v3';

  /* Localized strings provided by layout/theme.liquid (window.LABMAT_I18N), with
     English fallbacks so the cart still works if the bridge is absent. */
  var I = (function(){
    var d = window.LABMAT_I18N || {};
    return {
      added_toast:      d.added_toast      || '{title} added to quote',
      item:             d.item             || 'Item',
      reagent:          d.reagent          || 'Reagent',
      product:          d.product          || 'Product',
      grade:            d.grade            || 'Grade',
      format:           d.format           || 'Format',
      quantity:         d.quantity         || 'Quantity',
      remove:           d.remove           || 'Remove',
      empty_title:      d.empty_title      || 'Your quote is empty',
      empty_body:       d.empty_body       || 'Browse our catalogue and add products to begin.',
      browse_catalogue: d.browse_catalogue || 'Browse Catalogue',
      add_more:         d.add_more         || 'Add more products'
    };
  })();

  /* Active-language root ("/", "/en/", "/fr-ca/") so links keep the current language. */
  function localeRoot(){ var r = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; if (r.charAt(r.length - 1) !== '/') r += '/'; return r; }

  /* Stable per-line identity, shared with the PDP "Add to quote" button:
     productId + ':' + (variantId || 'default'). Lets the same product added
     from a collection card and from its product page collapse into one line
     instead of duplicating. */
  function lineKey(item){
    if (item && item._key) return item._key;
    var vid = (item && item.variantId != null && item.variantId !== '') ? item.variantId : 'default';
    return String(item ? item.id : '') + ':' + vid;
  }
  function qtyOf(x){ return parseInt(x && x.quantity != null ? x.quantity : (x && x.qty), 10) || 1; }

  var Q = {
    get: function(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } },
    set: function(a){
      try { localStorage.setItem(KEY, JSON.stringify(a)); } catch(e){}
      refreshAll();
      window.dispatchEvent(new CustomEvent('labmat:quote'));
      document.dispatchEvent(new CustomEvent('labmatQuote:changed', { detail: { items: a } }));
    },
    add: function(item){
      var a = Q.get();
      var key = lineKey(item);
      var f = a.find(function(x){ return lineKey(x) === key; });
      if(f){
        var nq = qtyOf(f) + 1;
        f.quantity = nq; f.qty = nq;
      } else {
        var fmts = (item.formats || '').split('|').filter(Boolean);
        if(fmts.length === 0) fmts = ['1 L'];
        var prs = (item.prices || '').split('|');
        var pricesArr = fmts.map(function(_, i){ return prs[i] !== undefined && prs[i] !== '' ? prs[i] : (item.price || '0'); });
        var firstPrice = pricesArr[0] || item.price || '0';
        a.push(Object.assign({ _key: key, quantity: 1, qty: 1, format: fmts[0], formatsArr: fmts, pricesArr: pricesArr, price: firstPrice }, item));
      }
      Q.set(a); return a;
    },
    remove: function(id){ Q.set(Q.get().filter(function(x){ return String(x.id) !== String(id); })); },
    updateQty: function(id, qty){
      qty = Math.max(1, parseInt(qty || 1, 10));
      var a = Q.get(); var f = a.find(function(x){ return String(x.id) === String(id); });
      if(f){ f.quantity = qty; f.qty = qty; Q.set(a); }
    },
    updateFormat: function(id, fmt){
      var a = Q.get(); var f = a.find(function(x){ return String(x.id) === String(id); });
      if(f){
        f.format = fmt;
        if(f.pricesArr && f.formatsArr){
          var idx = f.formatsArr.indexOf(fmt);
          if(idx >= 0 && f.pricesArr[idx] !== undefined){ f.price = f.pricesArr[idx]; }
        }
        Q.set(a);
      }
    },
    clear: function(){ Q.set([]); },
    count: function(){ return Q.get().length; },                                              /* distinct line items */
    totalUnits: function(){ return Q.get().reduce(function(t, x){ return t + qtyOf(x); }, 0); }, /* sum of quantities */
    totalEstimate: function(){ return Q.get().reduce(function(t, x){ return t + (parseFloat(x.price || 0) * qtyOf(x)); }, 0); },
    toast: function(msg){ showToast(msg); }
  };
  window.LabmatQuote = Q;

  function refreshAll(){
    var n = Q.totalUnits();   /* badge shows total units (qty), not just the number of distinct products */
    document.querySelectorAll('.js-quote-count').forEach(function(el){
      el.textContent = n;
      el.setAttribute('data-count', n);
      if (!el.classList.contains('js-quote-count-always')) el.style.display = n > 0 ? '' : 'none';
    });
    document.querySelectorAll('.js-quote-count-always').forEach(function(el){ el.textContent = n; el.setAttribute('data-count', n); });
  }

  function esc(s){ return String(s||'').replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }

  function fmtSelect(q){
    var fmts = q.formatsArr || (q.formats ? q.formats.split('|') : ['1 L']);
    var opts = fmts.map(function(f){ return '<option'+(f === q.format ? ' selected' : '')+'>'+esc(f)+'</option>'; }).join('');
    return '<select class="cart-fmt-select js-fmt" data-id="'+esc(q.id)+'">'+opts+'</select>';
  }

  function showToast(msg){
    var t = document.querySelector('.js-quote-toast');
    if(!t){
      t = document.createElement('div');
      t.className = 'quote-toast js-quote-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<span class="quote-toast-ico"><i class="fa-solid fa-check"></i></span><span class="quote-toast-msg"></span>';
      document.body.appendChild(t);
    }
    t.querySelector('.quote-toast-msg').textContent = msg;
    t.classList.add('is-open');
    clearTimeout(t._timer);
    t._timer = setTimeout(function(){ t.classList.remove('is-open'); }, 2400);
  }

  document.addEventListener('click', function(e){
    var add = e.target.closest('.js-add-to-quote');
    if(add){
      e.preventDefault();
      Q.add({
        id: add.dataset.id, handle: add.dataset.handle, title: add.dataset.title,
        sku: add.dataset.sku, url: add.dataset.url, image: add.dataset.image,
        formula: add.dataset.formula, cas: add.dataset.cas, grade: add.dataset.grade,
        price: add.dataset.price, prices: add.dataset.prices,
        formats: add.dataset.formats, description: add.dataset.description
      });
      add.classList.add('added');
      showToast(I.added_toast.replace('{title}', (add.dataset.title || I.item)));
      return;
    }
    var rm = e.target.closest('.js-rm');
    if(rm){ Q.remove(rm.dataset.id); }
  });
  document.addEventListener('change', function(e){
    var q = e.target.closest('.js-qty');   if(q){ Q.updateQty(q.dataset.id, q.value); return; }
    var f = e.target.closest('.js-fmt');   if(f){ Q.updateFormat(f.dataset.id, f.value); }
  });

  /* Toast requests from other scripts (e.g. the product-page "Add to quote"). */
  document.addEventListener('labmat:toast', function(e){ showToast((e.detail && e.detail.msg) || ''); });
  /* Keep the header count badge in sync whenever the cart changes anywhere,
     including edits made in the cart popup, the quote page, or another tab. */
  document.addEventListener('labmatQuote:changed', refreshAll);
  window.addEventListener('storage', function(e){ if (e.key === KEY) refreshAll(); });

  function renderQuotePageList(){
    var listEl = document.querySelector('.js-quote-page-list');
    var hidden = document.querySelector('.js-quote-items-hidden');
    if(!listEl) return;
    var arr = Q.get();
    if(arr.length === 0){
      listEl.innerHTML = '<div class="empty-quote"><h3>'+esc(I.empty_title)+'</h3><p>'+esc(I.empty_body)+'</p><a href="'+localeRoot()+'collections" class="btn btn-orange">'+esc(I.browse_catalogue)+'</a></div>';
      if(hidden) hidden.value = '';
      return;
    }
    var summary = [];
    var rows = arr.map(function(q){
      summary.push(qtyOf(q)+' x '+(q.title||I.item)+(q.formula ? ' ('+q.formula+')' : '')+' - '+(q.grade||'')+' / '+(q.format||'1 L'));
      return '<tr>'+
        '<td data-label="'+esc(I.product)+'"><a href="'+esc(q.url||'#')+'" class="cart-prod-name" style="text-decoration:none;">'+esc(q.title||I.item)+'</a></td>'+
        '<td data-label="'+esc(I.grade)+'">'+esc(q.grade||I.reagent)+'</td>'+
        '<td data-label="'+esc(I.format)+'">'+fmtSelect(q)+'</td>'+
        '<td data-label="'+esc(I.quantity)+'"><input type="number" class="cart-qty-input js-qty" data-id="'+esc(q.id)+'" min="1" value="'+qtyOf(q)+'"></td>'+
        '<td class="cart-row-remove"><button type="button" class="cart-remove-btn js-rm" data-id="'+esc(q.id)+'" aria-label="'+esc(I.remove)+'"><i class="fa-solid fa-xmark"></i></button></td>'+
      '</tr>';
    }).join('');
    listEl.innerHTML = '<table class="cart-modal-table"><thead><tr><th>'+esc(I.product)+'</th><th>'+esc(I.grade)+'</th><th>'+esc(I.format)+'</th><th>'+esc(I.quantity)+'</th><th></th></tr></thead><tbody>'+rows+'</tbody></table><div class="browse-cta" style="margin-top:16px;"><a href="'+localeRoot()+'collections" class="btn btn-outline-blue">'+esc(I.add_more)+'</a></div>';
    if(hidden) hidden.value = summary.join('\n');
  }
  window.addEventListener('labmat:quote', renderQuotePageList);

  function init(){
    refreshAll();
    renderQuotePageList();
    var form = document.getElementById('labmat-quote-form');
    if(form){
      form.addEventListener('submit', function(){
        var hidden = document.querySelector('.js-quote-items-hidden');
        if(hidden){
          var arr = Q.get();
          hidden.value = arr.map(function(q){
            return qtyOf(q)+' x '+(q.title||I.item)+(q.formula?' ('+q.formula+')':'')+' - '+(q.grade||'')+' / '+(q.format||'1 L')+(q.url?'  ['+q.url+']':'');
          }).join('\n');
        }
      });
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
